'use client';

import * as React from 'react';
import { cn } from '../utils/cn';

export type InputProps = React.InputHTMLAttributes<HTMLInputElement> & {
  /** Additional CSS classes */
  className?: string;
};

/**
 * Input component that follows the flat design system.
 * Uses design tokens for consistent styling across the application.
 */
const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          // Base styling with liquid glass design
          'flex h-10 w-full rounded-xl glass-input px-3 py-2',
          // Typography using design system tokens
          'text-sm font-regular text-foreground',
          // Placeholder styling
          'placeholder:text-muted-foreground/60',
          // Hover and focus states with glass effects
          'hover:glass-surface-hover',
          'focus-visible:outline-none focus-visible:glass-input-focus',
          // Disabled states
          'disabled:cursor-not-allowed disabled:opacity-50',
          // File input specific styles
          'file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground',
          className
        )}
        ref={ref}
        {...props}
      />
    );
  }
);

Input.displayName = 'Input';

export { Input };
